<template>
    <transition appear name="fade-transition">
        <span class="display__phone-number">
            <app-link v-if="link" :to="linkValue" target="_blank">
                {{ displayValue }}
            </app-link>
            <template v-else>
                {{ displayValue }}
            </template>
        </span>
    </transition>
</template>

<script>
import Display from './Display';
import { PhoneNumber } from '@/models';

export default {
    name: 'DisplayPhoneNumber',
    extends: Display,
    props: {
        link: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        phoneNumber() {
            let value = this.value;

            if (value && !(value instanceof PhoneNumber)) {
                value = new PhoneNumber(value);
            }

            return value;
        },
        displayValue() {
            if (this.value?.e164) {
                return this.value.e164;
            }

            if (!this.phoneNumber || !this.phoneNumber.e164) {
                return this.fallback ? this.fallback : '';
            }

            return this.phoneNumber.e164;
        },
        linkValue() {
            if (!this.phoneNumber || !this.phoneNumber.e164) {
                return null;
            }
            return `tel:+${this.phoneNumber.e164}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.display__phone-number {
    min-width: 10rem;
    text-align: right;
}
</style>
